<template>
	<div id="venuespanel" class="container row text-center">
    <div class="col-md-12 col-lg-6">
      <BarChart
        :data="venues"
        :colorScheme="'schemePaired'"
        :yDomain="[60, 0]"
        :width="1100"
        :height="760"
        :xRange="xRange" />
    </div>
    <div class="col-md-12 col-lg-6 d-lg-flex flex-lg-column justify-content-center">
      <h3>M Chinnaswamy Stadium </h3>
      <b>hosted the most matches (58 Matches) throughout 2008-16</b>
    </div>
	</div>
</template>

<script>
import BarChart from "./BarChart.vue";
import venues from "../assets/venues.json";

export default {
  name: "VenuesPanel",
  components: {
    BarChart
  },
  data() {
    return {
      venues,
      xRange: [0, 500]
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "orientationchange",
        this.detectOrientationChange
      );
    });
  },
  created() {
    this.detectOrientationChange();
  },
  methods: {
    detectOrientationChange() {
      // switch (window.orientation) {
      //   case 0:
      //     // landscape
      //     this.xRange = [0, 250];
      //     break;
      //   default:
      //     // portrait
      //     this.xRange = [0, 500];
      //     break;
      // }

      if (window.screen.width > 767) {
        this.xRange = [0, 500];
      } else {
        this.xRange = [0, 250];
      }
    }
  }
};
</script>

<style>
#venuespanel {
  padding: 20px;
  border-bottom: 1px grey solid;
}
</style>
